import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, vShow as _vShow, withKeys as _withKeys, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "ai-meeting-review" }
const _hoisted_2 = { class: "ai-meeting-heading" }
const _hoisted_3 = { class: "meeting-heading-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "meeting-error",
  role: "alert"
}
const _hoisted_6 = {
  key: 2,
  class: "meeting-card"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 3,
  class: "meeting-card",
  "aria-live": "polite"
}
const _hoisted_10 = {
  key: 4,
  class: "meeting-card"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  class: "meeting-review-tabs",
  role: "group",
  "aria-label": "Meeting review sections"
}
const _hoisted_13 = ["aria-pressed", "onClick"]
const _hoisted_14 = { class: "meeting-columns" }
const _hoisted_15 = { class: "meeting-card meeting-notes" }
const _hoisted_16 = { class: "meeting-card-heading" }
const _hoisted_17 = { class: "meeting-muted" }
const _hoisted_18 = { class: "meeting-summary-text" }
const _hoisted_19 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_20 = {
  key: 1,
  class: "meeting-list"
}
const _hoisted_21 = {
  key: 0,
  class: "meeting-chip"
}
const _hoisted_22 = {
  key: 1,
  class: "meeting-chip"
}
const _hoisted_23 = { class: "meeting-list" }
const _hoisted_24 = {
  key: 3,
  class: "meeting-more"
}
const _hoisted_25 = { class: "meeting-list" }
const _hoisted_26 = { class: "meeting-label" }
const _hoisted_27 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_28 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_29 = { class: "meeting-action-body" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "meeting-action-meta" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 1,
  class: "meeting-muted"
}
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "meeting-card"
}
const _hoisted_43 = {
  key: 1,
  class: "meeting-card meeting-save-card"
}
const _hoisted_44 = { class: "meeting-muted" }
const _hoisted_45 = {
  key: 0,
  class: "meeting-label"
}
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["value"]
const _hoisted_48 = {
  key: 1,
  class: "meeting-destination"
}
const _hoisted_49 = {
  key: 2,
  class: "meeting-label"
}
const _hoisted_50 = ["disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  key: 3,
  class: "meeting-destination"
}
const _hoisted_53 = {
  key: 4,
  class: "meeting-muted"
}
const _hoisted_54 = {
  key: 0,
  class: "meeting-label"
}
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 1,
  class: "meeting-muted"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 2,
  class: "meeting-card"
}
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "meeting-card meeting-transcript" }
const _hoisted_61 = { class: "meeting-card-heading" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "meeting-card" }
const _hoisted_64 = { class: "meeting-muted" }
const _hoisted_65 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_66 = {
  key: 1,
  class: "meeting-muted"
}
const _hoisted_67 = { class: "meeting-label" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  key: 1,
  class: "meeting-voice-badge"
}
const _hoisted_70 = {
  key: 2,
  class: "meeting-muted"
}
const _hoisted_71 = {
  key: 3,
  class: "meeting-muted"
}
const _hoisted_72 = ["onUpdate:modelValue", "onInput"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 1,
  class: "meeting-remember"
}
const _hoisted_75 = { class: "meeting-check" }
const _hoisted_76 = ["checked", "onChange"]
const _hoisted_77 = { class: "meeting-muted" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "meeting-label" }
const _hoisted_81 = ["onUpdate:modelValue", "disabled"]
const _hoisted_82 = ["value"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = {
  key: 3,
  role: "status"
}
const _hoisted_85 = {
  key: 4,
  class: "meeting-muted meeting-voice-saved"
}
const _hoisted_86 = ["disabled"]
const _hoisted_87 = { class: "meeting-card meeting-recording" }
const _hoisted_88 = { class: "meeting-card-heading" }
const _hoisted_89 = ["src"]
const _hoisted_90 = {
  key: 1,
  class: "meeting-muted"
}
const _hoisted_91 = {
  key: 2,
  class: "meeting-recording-options"
}
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  key: 6,
  class: "meeting-card"
}
const _hoisted_94 = { class: "meeting-card-heading" }
const _hoisted_95 = {
  key: 0,
  class: "meeting-share-list"
}
const _hoisted_96 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_97 = ["disabled", "onClick"]
const _hoisted_98 = { class: "meeting-label" }
const _hoisted_99 = {
  key: 1,
  class: "meeting-share-results"
}
const _hoisted_100 = ["onClick"]
const _hoisted_101 = {
  key: 0,
  class: "meeting-muted"
}
const _hoisted_102 = {
  key: 2,
  class: "meeting-share-pending"
}
const _hoisted_103 = ["aria-label", "onClick"]
const _hoisted_104 = ["disabled"]
const _hoisted_105 = {
  key: 3,
  class: "meeting-error",
  role: "alert"
}
const _hoisted_106 = {
  key: 4,
  role: "status",
  class: "meeting-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (!_ctx.data.shared)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          class: "meeting-back",
          to: _ctx.data.meetingID ? { path: '/meetings', query: { meetingID: _ctx.data.meetingID } } : '/meetings'
        }, {
          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
            _createTextVNode("← Back to meeting board", -1)
          ]))]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "meeting-eyebrow" }, "Meeting review", -1)),
        _createElementVNode("h1", null, _toDisplayString(_ctx.data.meetingName || 'Meeting notes'), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.data.shared ? 'Shared with you to watch and read.' : 'Check the notes and save a short recap for your team.'), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.notes)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["meeting-status", { 'meeting-status-saved': _ctx.accepted || _ctx.data.shared }])
            }, _toDisplayString(_ctx.data.shared ? 'Shared with you' : _ctx.accepted ? 'Saved to meeting' : 'Draft · not yet saved'), 3))
          : _createCommentVNode("", true),
        (_ctx.notes && !_ctx.readOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "ai-btn",
              disabled: !_ctx.canSave,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
            }, _toDisplayString(_ctx.busy ? 'Saving…' : 'Save recap to meeting'), 9, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.notes && _ctx.data.canShare && !_ctx.data.shared)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              ref: "shareButton",
              type: "button",
              class: "ai-btn ai-btn-ghost meeting-share-open",
              "aria-haspopup": "dialog",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openShare && _ctx.openShare(...args)))
            }, [
              _cache[32] || (_cache[32] = _createStaticVNode("<svg aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-0d09d1d7><circle cx=\"18\" cy=\"5\" r=\"3\" data-v-0d09d1d7></circle><circle cx=\"6\" cy=\"12\" r=\"3\" data-v-0d09d1d7></circle><circle cx=\"18\" cy=\"19\" r=\"3\" data-v-0d09d1d7></circle><path d=\"M8.6 13.5l6.8 4M15.4 6.5l-6.8 4\" data-v-0d09d1d7></path></svg>", 1)),
              _createTextVNode("Share" + _toDisplayString(_ctx.shares.length ? ' · ' + _ctx.shares.length : ''), 1)
            ], 512))
          : _createCommentVNode("", true),
        (!_ctx.data.shared)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/ai-hub#captures"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode("My captures", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.data.status === 'recording')
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _cache[34] || (_cache[34] = _createElementVNode("h2", null, "Your recording is saved in parts", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.data.uploadedChunks || 0) + " recording chunks are saved. If the recording tab closed, finish with the recording uploaded so far.", 1),
          (_ctx.data.owner)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "ai-btn",
                disabled: _ctx.busy || !_ctx.data.uploadedChunks,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)))
              }, "Finish uploaded recording", 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.data.owner)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ai-btn ai-btn-ghost",
                disabled: _ctx.busy,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteRecording && _ctx.deleteRecording(...args)))
              }, "Discard recording", 8, _hoisted_8))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.data.status === 'processing' || !_ctx.data.status)
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.data.stage || 'Loading meeting notes'), 1),
            _cache[35] || (_cache[35] = _createElementVNode("p", null, "You can close this page. When the notes are ready they'll be on the meeting's History tab.", -1))
          ]))
        : (_ctx.data.status === 'error')
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
              _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Processing needs attention", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.data.error), 1),
              (_ctx.data.owner)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ai-btn",
                    disabled: _ctx.busy,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)))
                  }, "Retry processing", 8, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.notes)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewTabs, (tab) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: tab.key,
                      type: "button",
                      class: _normalizeClass({ active: _ctx.activeTab === tab.key }),
                      "aria-pressed": _ctx.activeTab === tab.key,
                      onClick: ($event: any) => (_ctx.activeTab = tab.key)
                    }, _toDisplayString(tab.label), 11, _hoisted_13))
                  }), 128))
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_14, [
                  _createElementVNode("section", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[37] || (_cache[37] = _createElementVNode("h2", null, "Notes & actions", -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.notes.actionItems.length) + " action item" + _toDisplayString(_ctx.notes.actionItems.length === 1 ? '' : 's') + " · " + _toDisplayString(_ctx.notes.decisions.length) + " decision" + _toDisplayString(_ctx.notes.decisions.length === 1 ? '' : 's'), 1)
                    ]),
                    (_ctx.readOnly)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.notes.summary), 1),
                          _cache[39] || (_cache[39] = _createElementVNode("h3", null, "Action items", -1)),
                          (!_ctx.notes.actionItems.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, "No action items."))
                            : (_openBlock(), _createElementBlock("ul", _hoisted_20, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.actionItems, (item, i) => {
                                  return (_openBlock(), _createElementBlock("li", { key: i }, [
                                    _createTextVNode(_toDisplayString(item.text), 1),
                                    (_ctx.assigneeName(item))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.assigneeName(item)), 1))
                                      : _createCommentVNode("", true),
                                    (item.due)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Due " + _toDisplayString(item.due), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])),
                          (_ctx.notes.decisions.length)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Decisions", -1)),
                                _createElementVNode("ul", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.decisions, (d, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: 'd'+i
                                    }, _toDisplayString(d), 1))
                                  }), 128))
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.notes.openIssues.length)
                            ? (_openBlock(), _createElementBlock("details", _hoisted_24, [
                                _createElementVNode("summary", null, "Open issues (" + _toDisplayString(_ctx.notes.openIssues.length) + ")", 1),
                                _createElementVNode("ul", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.openIssues, (o, i) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: 'o'+i
                                    }, _toDisplayString(o), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("label", _hoisted_26, [
                            _cache[40] || (_cache[40] = _createTextVNode("Summary", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: "meeting-fit",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.notes.summary) = $event)),
                              rows: "3",
                              onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fitTextarea && _ctx.fitTextarea(...args)))
                            }, null, 544), [
                              [_vModelText, _ctx.notes.summary]
                            ])
                          ]),
                          _cache[42] || (_cache[42] = _createElementVNode("h3", null, [
                            _createTextVNode("Action items "),
                            _createElementVNode("span", { class: "meeting-muted" }, "· ticked items go on the meeting board")
                          ], -1)),
                          (!_ctx.notes.actionItems.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, "No action items were identified."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.actionItems, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: _normalizeClass(["meeting-action", { 'meeting-action-off': !item.addToBoard }])
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "meeting-action-check",
                                "onUpdate:modelValue": ($event: any) => ((item.addToBoard) = $event),
                                "aria-label": 'Add to the meeting board: ' + item.text
                              }, null, 8, _hoisted_28), [
                                [_vModelCheckbox, item.addToBoard]
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "meeting-fit meeting-inline",
                                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                                  rows: "1",
                                  onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fitTextarea && _ctx.fitTextarea(...args))),
                                  "aria-label": "Action item"
                                }, null, 40, _hoisted_30), [
                                  [_vModelText, item.text]
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((item.assigneeEmployeeID) = $event),
                                    "aria-label": "Assigned to"
                                  }, [
                                    _cache[41] || (_cache[41] = _createElementVNode("option", { value: null }, "Unassigned", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendees, (a) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: a.ID,
                                        value: Number(a.ID)
                                      }, _toDisplayString(a.Name), 9, _hoisted_33))
                                    }), 128))
                                  ], 8, _hoisted_32), [
                                    [_vModelSelect, item.assigneeEmployeeID]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((item.due) = $event),
                                    placeholder: "No due date",
                                    "aria-label": "Due"
                                  }, null, 8, _hoisted_34), [
                                    [_vModelText, item.due]
                                  ]),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "meeting-remove",
                                    onClick: ($event: any) => (_ctx.notes.actionItems.splice(i,1))
                                  }, "Remove", 8, _hoisted_35)
                                ])
                              ])
                            ], 2))
                          }), 128)),
                          _cache[43] || (_cache[43] = _createElementVNode("h3", null, "Decisions", -1)),
                          (!_ctx.notes.decisions.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_36, "No decisions were identified."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.decisions, (_, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'd'+i,
                              class: "meeting-line"
                            }, [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "meeting-fit meeting-inline",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.notes.decisions[i]) = $event),
                                rows: "1",
                                onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.fitTextarea && _ctx.fitTextarea(...args))),
                                "aria-label": "Decision"
                              }, null, 40, _hoisted_37), [
                                [_vModelText, _ctx.notes.decisions[i]]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "meeting-remove",
                                onClick: ($event: any) => (_ctx.notes.decisions.splice(i,1))
                              }, "Remove", 8, _hoisted_38)
                            ]))
                          }), 128)),
                          _createElementVNode("details", {
                            class: "meeting-more",
                            onToggle: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.fitAll && _ctx.fitAll(...args)))
                          }, [
                            _createElementVNode("summary", null, "Open issues (" + _toDisplayString(_ctx.notes.openIssues.length) + ")", 1),
                            (!_ctx.notes.openIssues.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_39, "No open issues were identified."))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes.openIssues, (_, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'o'+i,
                                class: "meeting-line"
                              }, [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "meeting-fit meeting-inline",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.notes.openIssues[i]) = $event),
                                  rows: "1",
                                  onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fitTextarea && _ctx.fitTextarea(...args))),
                                  "aria-label": "Open issue"
                                }, null, 40, _hoisted_40), [
                                  [_vModelText, _ctx.notes.openIssues[i]]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "meeting-remove",
                                  onClick: ($event: any) => (_ctx.notes.openIssues.splice(i,1))
                                }, "Remove", 8, _hoisted_41)
                              ]))
                            }), 128))
                          ], 32)
                        ], 64))
                  ]),
                  _createElementVNode("aside", null, [
                    (_ctx.data.shared)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_42, [...(_cache[44] || (_cache[44] = [
                          _createElementVNode("h2", null, "Shared with you", -1),
                          _createElementVNode("p", { class: "meeting-muted" }, "You can watch the recording and read the notes and transcript. Only the person who recorded the meeting can change them.", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("section", _hoisted_43, [
                          _createElementVNode("h2", null, _toDisplayString(_ctx.accepted ? 'Saved recap' : 'Save your recap'), 1),
                          _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.accepted ? 'These notes are available from the meeting board and History.' : 'Check the notes, then save them to this meeting run. Ticked action items are added to its board.'), 1),
                          (!_ctx.data.meetingID)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_45, [
                                _cache[46] || (_cache[46] = _createTextVNode("Meeting", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.meetingID) = $event)),
                                  disabled: _ctx.accepted || !!_ctx.data.meetingID,
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => {_ctx.historyID = ''; _ctx.loadSelection()})
                                }, [
                                  _cache[45] || (_cache[45] = _createElementVNode("option", { value: "" }, "Choose a meeting", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meetings, (m) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: m.id,
                                      value: m.id
                                    }, _toDisplayString(m.name), 9, _hoisted_47))
                                  }), 128))
                                ], 40, _hoisted_46), [
                                  [_vModelSelect, _ctx.meetingID]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _cache[47] || (_cache[47] = _createElementVNode("span", null, "Meeting", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.data.meetingName), 1)
                              ])),
                          (!_ctx.data.historyID)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_49, [
                                _cache[49] || (_cache[49] = _createTextVNode("Meeting run", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.historyID) = $event)),
                                  disabled: _ctx.accepted || !!_ctx.data.historyID,
                                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.loadSelection && _ctx.loadSelection(...args)))
                                }, [
                                  _cache[48] || (_cache[48] = _createElementVNode("option", { value: "" }, "Choose a meeting run", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.histories, (h) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: h.ID,
                                      value: h.ID
                                    }, _toDisplayString(new Date(h.StartDate).toLocaleString()) + _toDisplayString(h.EndDate ? '' : ' · in progress'), 9, _hoisted_51))
                                  }), 128))
                                ], 40, _hoisted_50), [
                                  [_vModelSelect, _ctx.historyID]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _cache[50] || (_cache[50] = _createElementVNode("span", null, "Meeting run", -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.selectedRunLabel), 1)
                              ])),
                          (!_ctx.histories.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_53, "Start a meeting run in Meetings before adding these notes."))
                            : _createCommentVNode("", true),
                          (!_ctx.accepted)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (_ctx.boardCount)
                                  ? (_openBlock(), _createElementBlock("label", _hoisted_54, [
                                      _createTextVNode("Add " + _toDisplayString(_ctx.boardCount) + " action item" + _toDisplayString(_ctx.boardCount === 1 ? '' : 's') + " to column", 1),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.column) = $event))
                                      }, [
                                        _cache[51] || (_cache[51] = _createElementVNode("option", { value: "" }, "Choose a column", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (c) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: c.name,
                                            value: c.name
                                          }, _toDisplayString(c.name), 9, _hoisted_55))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, _ctx.column]
                                      ])
                                    ]))
                                  : (_ctx.notes.actionItems.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_56, "No action items are ticked, so nothing is added to the board."))
                                    : _createCommentVNode("", true),
                                _createElementVNode("button", {
                                  class: "ai-btn meeting-save",
                                  disabled: !_ctx.canSave,
                                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
                                }, _toDisplayString(_ctx.busy ? 'Saving…' : 'Save recap to meeting'), 9, _hoisted_57)
                              ], 64))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 6,
                                to: { path: '/meetings', query: { meetingID: _ctx.data.meetingID } }
                              }, {
                                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                  _createTextVNode("Open Meetings", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"]))
                        ])),
                    (_ctx.data.owner && !_ctx.accepted)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_58, [
                          _cache[53] || (_cache[53] = _createElementVNode("h2", null, "Request changes", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.feedback) = $event)),
                            rows: "4",
                            placeholder: "What should be clarified or changed?"
                          }, null, 512), [
                            [_vModelText, _ctx.feedback]
                          ]),
                          _createElementVNode("button", {
                            class: "ai-btn ai-btn-ghost",
                            disabled: _ctx.busy || !_ctx.feedback.trim(),
                            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.revise && _ctx.revise(...args)))
                          }, "Revise notes", 8, _hoisted_59)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 512), [
                  [_vShow, _ctx.activeTab === 'notes']
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass({ 'meeting-columns': !_ctx.data.shared })
                }, [
                  _createElementVNode("section", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _cache[54] || (_cache[54] = _createElementVNode("h2", null, "Transcript", -1)),
                      _createElementVNode("button", {
                        class: "meeting-text-link",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.activeTab = 'recording'))
                      }, "Open recording")
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("p", { class: "meeting-muted" }, "Speaker name corrections appear here as you make them.", -1)),
                    _createElementVNode("pre", null, _toDisplayString(_ctx.labelledTranscript || 'No transcript is available.'), 1)
                  ]),
                  (!_ctx.data.shared)
                    ? (_openBlock(), _createElementBlock("aside", _hoisted_62, [
                        _createElementVNode("section", _hoisted_63, [
                          _cache[60] || (_cache[60] = _createElementVNode("h2", null, "Identify speakers", -1)),
                          _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.fromCall ? 'Recorded by the Ironbook Notetaker. Each voice is a person from the call, named by Teams or Zoom. Check the names against playback.' : _ctx.speakerMap.length ? 'Voice groups are estimates, not a head count. Confirm names against playback. If one person appears more than once, combine their groups below.' : 'Voices could not be reliably separated. The transcript is still available below.'), 1),
                          (!_ctx.fromCall)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.visualExplanation), 1))
                            : _createCommentVNode("", true),
                          (_ctx.speakerMap.some(s => s.source === 'voice'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_66, "Names marked “recognised by voice” come from voice profiles people chose to save. Correct any that are wrong; that won't change anyone's saved voice."))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakerMap, (s) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: s.speaker,
                              class: "meeting-voice"
                            }, [
                              _createElementVNode("label", _hoisted_67, [
                                _createTextVNode(_toDisplayString(_ctx.displaySpeaker(s.speaker)), 1),
                                (s.sameAs)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, " · combined voice"))
                                  : _createCommentVNode("", true),
                                (s.source === 'voice' && s.confidence !== 'confirmed')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_69, " · Recognised by voice — check it's right"))
                                  : (s.source === 'platform' && s.confidence !== 'confirmed')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, " · Name from the call"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_71, " · " + _toDisplayString(s.confidence === 'confirmed' ? 'Name confirmed by reviewer' : s.name ? 'Suggested name — please confirm' : 'Name not identified'), 1)),
                                (!s.sameAs)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 4,
                                      "onUpdate:modelValue": ($event: any) => ((s.name) = $event),
                                      placeholder: "Enter name, or leave unknown",
                                      onInput: ($event: any) => (_ctx.nameEdited(s))
                                    }, null, 40, _hoisted_72)), [
                                      [_vModelText, s.name]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              (!s.sameAs && _ctx.myVoice?.name && !_ctx.isMe(s) && !_ctx.speakerMap.some(v => !v.sameAs && _ctx.isMe(v)))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "meeting-remove",
                                    onClick: ($event: any) => {s.name = _ctx.myVoice.name; _ctx.nameEdited(s)}
                                  }, "This is me", 8, _hoisted_73))
                                : _createCommentVNode("", true),
                              (_ctx.canRemember(s))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                    _createElementVNode("label", _hoisted_75, [
                                      _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: _ctx.rememberVoice === s.speaker,
                                        onChange: ($event: any) => (_ctx.toggleRemember(s, $event))
                                      }, null, 40, _hoisted_76),
                                      _cache[56] || (_cache[56] = _createTextVNode("Remember my voice so future recordings name me automatically", -1))
                                    ]),
                                    _createElementVNode("p", _hoisted_77, [
                                      _createTextVNode(_toDisplayString(_ctx.myVoice.consentText), 1),
                                      (_ctx.myVoice.enrolled)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" Your voice is already remembered; ticking this replaces it with this recording.")
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                type: "button",
                                class: "meeting-remove",
                                onClick: ($event: any) => (_ctx.playSpeaker(s.speaker))
                              }, "Listen to this voice", 8, _hoisted_78),
                              (s.confidence !== 'confirmed' && _ctx.visualEvidence(s.speaker))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    type: "button",
                                    class: "meeting-remove meeting-evidence",
                                    onClick: ($event: any) => (_ctx.playAt(_ctx.visualEvidence(s.speaker).evidenceTimes[0]))
                                  }, "Check the displayed name in the video", 8, _hoisted_79))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_80, [
                                _cache[58] || (_cache[58] = _createTextVNode("Combine with", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((s.sameAs) = $event),
                                  disabled: _ctx.speakerMap.some(v => v.sameAs === s.speaker),
                                  onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.savedMessage = ''))
                                }, [
                                  _cache[57] || (_cache[57] = _createElementVNode("option", { value: undefined }, "Keep separate", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speakerMap.filter(v => v.speaker !== s.speaker && !v.sameAs), (v) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: v.speaker,
                                      value: v.speaker
                                    }, _toDisplayString(_ctx.displaySpeaker(v.speaker)) + _toDisplayString(v.name ? ' · ' + v.name : ''), 9, _hoisted_82))
                                  }), 128))
                                ], 40, _hoisted_81), [
                                  [_vModelSelect, s.sameAs]
                                ])
                              ])
                            ]))
                          }), 128)),
                          (_ctx.speakerMap.length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "ai-btn ai-btn-ghost",
                                disabled: _ctx.busy,
                                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.saveSpeakers && _ctx.saveSpeakers(...args)))
                              }, _toDisplayString(_ctx.rememberVoice ? 'Save and remember my voice' : 'Save speaker corrections'), 9, _hoisted_83))
                            : _createCommentVNode("", true),
                          (_ctx.savedMessage)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_84, _toDisplayString(_ctx.savedMessage), 1))
                            : _createCommentVNode("", true),
                          (_ctx.myVoice?.enrolled)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_85, [
                                _cache[59] || (_cache[59] = _createTextVNode("Your voice is remembered for this company's meeting recordings. ", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "meeting-text-link",
                                  disabled: _ctx.busy,
                                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.forgetVoice && _ctx.forgetVoice(...args)))
                                }, "Forget my voice", 8, _hoisted_86)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 2), [
                  [_vShow, _ctx.activeTab === 'transcript']
                ]),
                _withDirectives(_createElementVNode("section", _hoisted_87, [
                  _createElementVNode("div", _hoisted_88, [
                    _cache[61] || (_cache[61] = _createElementVNode("h2", null, "Recording", -1)),
                    _createElementVNode("button", {
                      class: "meeting-text-link",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.activeTab = 'transcript'))
                    }, "Read transcript")
                  ]),
                  _cache[64] || (_cache[64] = _createElementVNode("p", { class: "meeting-muted" }, "Use playback to check a passage or confirm who was speaking.", -1)),
                  (_ctx.data.recordingUrl)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        playsinline: "",
                        controls: "",
                        preload: "metadata",
                        src: _ctx.api + _ctx.data.recordingUrl
                      }, null, 8, _hoisted_89))
                    : (_openBlock(), _createElementBlock("p", _hoisted_90, "The recording has been deleted. Notes and transcript are still available.")),
                  (_ctx.data.recordingUrl && _ctx.data.owner)
                    ? (_openBlock(), _createElementBlock("details", _hoisted_91, [
                        _cache[62] || (_cache[62] = _createElementVNode("summary", null, "Recording options", -1)),
                        _createElementVNode("button", {
                          class: "meeting-remove",
                          disabled: _ctx.busy,
                          onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.deleteRecording && _ctx.deleteRecording(...args)))
                        }, "Delete recording", 8, _hoisted_92),
                        _cache[63] || (_cache[63] = _createElementVNode("p", { class: "meeting-muted" }, "Deleting the recording keeps the notes and transcript.", -1))
                      ]))
                    : _createCommentVNode("", true)
                ], 512), [
                  [_vShow, _ctx.activeTab === 'recording']
                ])
              ], 64))
            : (_ctx.data.status === 'consumed')
              ? (_openBlock(), _createElementBlock("p", _hoisted_93, "This recording was discarded."))
              : _createCommentVNode("", true),
    (_ctx.shareOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: "meeting-share-backdrop",
          onClick: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeShare && _ctx.closeShare(...args)), ["self"]))
        }, [
          _createElementVNode("section", {
            class: "meeting-card meeting-share-dialog",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "meeting-share-title",
            onKeydown: _cache[28] || (_cache[28] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeShare && _ctx.closeShare(...args)), ["esc"]))
          }, [
            _createElementVNode("div", _hoisted_94, [
              _cache[65] || (_cache[65] = _createElementVNode("h2", { id: "meeting-share-title" }, "Share recording", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "meeting-share-close",
                "aria-label": "Close sharing",
                onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.closeShare && _ctx.closeShare(...args)))
              }, "×")
            ]),
            _cache[67] || (_cache[67] = _createElementVNode("p", { class: "meeting-muted" }, "People you add can watch the recording and read the notes and transcript, but can't change them. They get an email with the link.", -1)),
            (_ctx.shares.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_95, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shares, (p) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: p.ID
                    }, [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(p.Name), 1),
                        (p.SharedBy)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_96, " · shared by " + _toDisplayString(p.SharedBy), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "meeting-remove",
                        disabled: _ctx.busy,
                        onClick: ($event: any) => (_ctx.unshare(p))
                      }, "Remove", 8, _hoisted_97)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("label", _hoisted_98, [
              _cache[66] || (_cache[66] = _createTextVNode("Add people", -1)),
              _withDirectives(_createElementVNode("input", {
                ref: "shareInput",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.shareSearch) = $event)),
                placeholder: "Search by name",
                autocomplete: "off"
              }, null, 512), [
                [_vModelText, _ctx.shareSearch]
              ])
            ]),
            (_ctx.shareSearch.trim())
              ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shareMatches, (p) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: p.ID,
                      type: "button",
                      onClick: ($event: any) => {_ctx.sharePending.push(p); _ctx.shareSearch = ''}
                    }, _toDisplayString(p.Name), 9, _hoisted_100))
                  }), 128)),
                  (!_ctx.shareMatches.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_101, "No match. Only people with an Ironbook sign-in can be added."))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.sharePending.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharePending, (p, i) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: p.ID,
                      class: "meeting-chip"
                    }, [
                      _createTextVNode(_toDisplayString(p.Name), 1),
                      _createElementVNode("button", {
                        type: "button",
                        "aria-label": 'Remove ' + p.Name,
                        onClick: ($event: any) => (_ctx.sharePending.splice(i,1))
                      }, "×", 8, _hoisted_103)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "ai-btn ai-btn-ghost meeting-save",
              disabled: _ctx.busy || !_ctx.sharePending.length,
              onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)))
            }, "Share and email " + _toDisplayString(_ctx.sharePending.length || ''), 9, _hoisted_104),
            (_ctx.shareError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_ctx.shareError), 1))
              : _createCommentVNode("", true),
            (_ctx.shareMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_106, _toDisplayString(_ctx.shareMessage), 1))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}